import React, { PureComponent } from "react";

import Select from "react-select";

import { Modal } from "react-bootstrap";

import { Accordion, Button, ButtonGroup, Dropdown, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import BYOMModalContainer from "containers/UnifiedProject/SelectData/BYOMModal";
import TestTrainSplitContainer from "containers/UnifiedProject/SelectData/TestTrainSplit";

import { SELECT_DATA_ADVANCED_OPTIONS } from "containers/UnifiedProject/reducer";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

export default class SelectDataAdvanced extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isBYOM: false,
      modelName: undefined,
      modelURL: undefined,
      modelUsername: undefined,
      modelPassword: undefined
    };
  }

  renderHeader() {
    const {
      updateOption,
      options,
      advancedDatasetOptions,
      BYOMURL,
      isForecast,
      isNext,
      copyTransformFromSetup,
      fieldTypes,
      dataset
    } = this.props;

    const selectedTab = options ? options["selectedTab"] : SELECT_DATA_ADVANCED_OPTIONS.FIELDS;

    if (!advancedDatasetOptions || advancedDatasetOptions.length <= 1) {
      return <React.Fragment />;
    }

    const isBYOMEnabled = isEnabled("external-models");
    const validAdvancedDatasetOptions = dataset
      ? advancedDatasetOptions.filter((option) => !isNext || option !== "View Data")
      : advancedDatasetOptions.filter((option) => option !== "View Data" && option !== "Specialized AI Models");

    const hasTypeUpdates =
      Object.keys(fieldTypes ?? {}).filter((column) => fieldTypes[column] == "Categorical").length !=
      (dataset?.transformations?.projections ?? []).length;

    return (
      <div className={styles.selectDataAdvancedHeader}>
        <ButtonGroup>
          {validAdvancedDatasetOptions.map((elem, i) => {
            return (
              <Button onClick={() => updateOption("selectedTab", elem)} key={elem} active={selectedTab === elem}>
                {elem}
              </Button>
            );
          })}
        </ButtonGroup>
        {/*BYOMURL
          ? "External deployed model added."
          : "Do you already have a deployed model that you would like to evaluate with the Aible models?"*/}
        <ButtonGroup style={{ marginLeft: "10px" }}>
          {isBYOMEnabled && !isForecast && (
            <Button onClick={() => updateOption("selectedTab", "BYOM")} active={selectedTab === "BYOM"}>
              {BYOMURL ? "Edit External Model" : "I have a model I want to compare"}
            </Button>
          )}
          {isEnabled("test-train-split") && !isForecast && (
            <Button
              onClick={() => updateOption("selectedTab", "TEST_TRAIN_SPLIT")}
              active={selectedTab === "TEST_TRAIN_SPLIT"}
            >
              {"I want to specify my training and evaluation rows"}
            </Button>
          )}
        </ButtonGroup>
        {hasTypeUpdates && (
          <div className={styles.byom}>
            <Button style={{ marginLeft: "10px" }} onClick={() => copyTransformFromSetup(dataset.id)}>
              Apply Updates
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { id, runId, datasetId, nextId, updateOption, updateIsBYOMModal, children, options, BYOMURL } = this.props;

    const selectedTab = options ? options["selectedTab"] : SELECT_DATA_ADVANCED_OPTIONS.FIELDS;

    return (
      <div className={styles.selectDataAdvancedWrapper}>
        <Accordion
          header={
            <div className={styles.selectDataAdvancedTitle}>
              <Icon type="toolsPurple" style={{ marginRight: "8px" }} size={16} />
              {"Advanced Settings"}
            </div>
          }
          shrinkHeader
        >
          {this.renderHeader()}
          {selectedTab === "TEST_TRAIN_SPLIT" ? (
            <TestTrainSplitContainer id={id} datasetId={datasetId} nextId={nextId} runId={runId} />
          ) : selectedTab === "BYOM" ? (
            <BYOMModalContainer id={id} />
          ) : (
            <div className={styles.selectDataAdvanced}>{children}</div>
          )}
        </Accordion>
      </div>
    );
  }
}
